import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import { breakpoints, debounce, bicentennialSwiperConfig } from '../../helpers/index';

Swiper.use([Navigation, Pagination, A11y]);

class StatisticsRow extends Component {
  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector(
        '.swiper-container'
      ),
      swiperSlides: this.el.querySelectorAll(
        '.swiper-slide'
      ),
      swiperPagination: this.el.querySelector(
        '.swiper-pagination'
      ),
      swiperButtonPrev: this.el.querySelector(
        '.swiper-btn-prev'
      ),
      swiperButtonNext: this.el.querySelector(
        '.swiper-btn-next'
      ),
      swiperControls: this.el.querySelector(
        '.swiper-controls'
      )
    };

    this.columns = parseInt(this.el.dataset.columns, 10);

    if (this.el.classList.contains('bicentennial-content-carousel')) {
      this.extraConfig = {
        spaceBetween: 135
      }
    }

    if (this.el.classList.contains('bicentennial-content-carousel--related-content')) {
      this.extraConfig = {
        spaceBetween: 30
      }
    }

    if (this.el.classList.contains('bicentennial-content-card-row')) {
      this.extraConfig = {
        spaceBetween: 0
      }

      this.isDesktopMultiRow = true;
    }

    if (this.el.classList.contains('bicentennial-statistics-row')) {
      this.isDesktopMultiRow = true;
    }

    this.initSlider();
  }

  resetSlide() {
    if (window.matchMedia(`(min-width: ${breakpoints.tabletLandscape}px)`).matches) {
      this.swiper.slideTo(0);
    }
  }

  handleSwiperResize(swiper) {
    if (swiper.isLocked) {
      this.dom.swiperControls.style.visibility = 'hidden';
    } else {
      this.dom.swiperControls.style.removeProperty('visibility');
    }

    if (this.isDesktopMultiRow) {
      this.resetSlide();
    }
  }

  initSlider() {
    const totalPanels = this.dom.swiperSlides.length;
    const config = { ...bicentennialSwiperConfig, ...this.extraConfig };

    this.swiper = new Swiper(this.dom.swiperContainer, {
      ...config,
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerView: totalPanels > 2 ? 2 : totalPanels,
        },
        [breakpoints.tabletLandscape]: {
          slidesPerView: totalPanels > this.columns ? this.columns : totalPanels,
          speed: this.isDesktopMultiRow ? 0 : config.speed
        }
      },
      navigation: {
        prevEl: this.dom.swiperButtonPrev,
        nextEl: this.dom.swiperButtonNext
      },
      a11y: {
        prevSlideMessage: this.el.dataset.previousSlideAriaLabel,
        nextSlideMessage: this.el.dataset.nextSlideAriaLabel
      },
      pagination: {
        el: this.dom.swiperPagination,
        clickable: true,
      }
    });

    this.swiper.on('resize', debounce(this.handleSwiperResize.bind(this), 100));
    this.swiper.on('afterInit', window.dispatchEvent(new Event('resize')));
  }
}

export default StatisticsRow;
